import React from "react";

const Footer = ({ color, extraPadding, fontColor }) => {
  const currentYear = () => {
    let currentDate = new Date();
    return currentDate.getFullYear();
  };
  return (
    <div className="uk-position-relative">
      <div
        className="footerwrp"
        style={{ backgroundColor: color, paddingLeft: extraPadding }}
      >
        <div uk-grid="" className="uk-grid">
          <div className="uk-width-1-2">
            <div className="txtwrp">
              <span style={{ color: fontColor }}>
                © ZONG {currentYear()}. All rights reserved.
              </span>
            </div>
          </div>
          <div className="uk-width-1-2">
            <div className="brandName">
              <span>
                Powered by{" "}
                <a href="https://www.convexinteractive.com/" target="_blank">
                  Convex Interactive
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
